import type { ComponentType } from 'react';
import type {
  IInvestigationReport,
  IInvestigationReportType,
} from '@apis/investigationReports';
import { ContractorAnalysisRecentCard } from '../Cards/ContractorAnalysisRecentCard';
import { DailyRouteRecentCard } from '../Cards/DailyRouteRecentCard';
import { ProjectOverviewRecentCard } from '../Cards/ProjectOverviewRecentCard';
import { WorkerTimesheetRecentCard } from '../Cards/WorkerTimesheetRecentCard';
import { DefaultRecentCard } from './DefaultRecentCard';

export interface IRecentCardProps {
  submission: IInvestigationReport;
  siteId: string;
}

/**
 * Per-report-type recent-card components. Cards register here to take over
 * the rail's rendering for their type; everything else falls through to
 * `DefaultRecentCard`. Each registered card is responsible for reading the
 * variant fields off `submission` (e.g. `tagId`, `equipmentName`) — the
 * registry guarantees by key that this card only sees its own type.
 */
const REGISTRY: Partial<
  Record<IInvestigationReportType, ComponentType<IRecentCardProps>>
> = {
  dailyRoute: DailyRouteRecentCard,
  contractorAnalysis: ContractorAnalysisRecentCard,
  workersTimesheet: WorkerTimesheetRecentCard,
  projectOverview: ProjectOverviewRecentCard,
};

export function getRecentCard(
  type: IInvestigationReportType,
): ComponentType<IRecentCardProps> {
  return REGISTRY[type] ?? DefaultRecentCard;
}
